import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Layers, WalkOfShameLayers} from "../view/WalkOfShameLayers";
import {WalkOfShame} from "../WalkOfShame";
import {TimelineLite} from "gsap";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {WalkOfShameHelper} from "../../core/utils/WalkOfShameHelper";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";

export class FreespinIntro extends ContinueScreen {
    private readonly _animationBelow: PIXI.spine.Spine;
    private readonly _bg: PIXI.Sprite;
    private readonly _title: PIXI.Sprite;
    private readonly _animationAbove: PIXI.spine.Spine;
    private readonly _fsLeftCount: PIXI.Text;

    constructor() {
        super(WalkOfShameLayers.getLayer(Layers.SCREENS)!);

        this._animationBelow = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("intro"));
        this._animationBelow.visible = false;
        this._animationBelow.position.set(360);

        this._bg = new PIXI.Sprite();
        this._bg.anchor.set(0.5);
        this._bg.position.set(360);

        this._animationAbove = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("intro"));
        this._animationAbove.visible = false;
        this._animationAbove.position.set(360);

        this._title = new PIXI.Sprite();
        this._title.anchor.set(0.5);
        this._title.position.set(360, 445);

        this._fsLeftCount = new PIXI.Text("", new PIXI.TextStyle({
            fill: 0xffffff,
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 50,
            stroke: "#126362",
            strokeThickness: 12,
            lineJoin: "round"
        }));
        this._fsLeftCount.anchor.set(0.5);
        this._fsLeftCount.position.set(360, 540);

        this.addChild(this._animationBelow, this._bg, this._animationAbove, this._title, this._fsLeftCount, this._continueButton);
    }

    public show(onContinueCallBack: () => void): void {
        const bgTexturePrefix: string = "FS_SFS_intro/",
            bgTexturePostfix: string = "FS_intro",
            textTexturePostfix: string = "FStext_intro",
            tl: TimelineLite = new TimelineLite(),
            fsLeft: number = WalkOfShame.model.isRestore ? WalkOfShame.model.parsedInitData.freespinsLeft : WalkOfShame.model.parsedGameData.freespinsLeft,
            nextMode: string = WalkOfShame.model.isRestore ? WalkOfShame.model.parsedInitData.nextMode : WalkOfShame.model.parsedGameData.nextMode,
            isUpgrade: boolean = (WalkOfShame.model.data && WalkOfShame.model.data.mode === WalkOfShameGameMode.FREESPIN && nextMode.indexOf("SUPER_FREESPIN") > -1);

        this._bg.texture = (nextMode === WalkOfShameGameMode.FREESPIN ? WalkOfShame.assetLoader.getTextures(bgTexturePrefix + bgTexturePostfix)[0] : WalkOfShame.assetLoader.getTextures(bgTexturePrefix + "S" + bgTexturePostfix)[0]);
        this._title.texture = (nextMode === WalkOfShameGameMode.FREESPIN ? WalkOfShame.assetLoader.getTextures(bgTexturePrefix + textTexturePostfix)[0] : WalkOfShame.assetLoader.getTextures(bgTexturePrefix + "S" + textTexturePostfix)[0]);
        this._fsLeftCount.text = (fsLeft + " " + (fsLeft === 1 ? WalkOfShame.apiPlugin.translations.translate("SPIN") : WalkOfShame.apiPlugin.translations.translate("SPINS")));

        super.show(onContinueCallBack);

        this._continueButton.visible = false;
        this._continueButton.enable(false);
        this._bg.visible = true;
        this._title.visible = true;
        this._fsLeftCount.visible = (fsLeft > 0);

        WalkOfShame.background.turnOffClickAbles();

        tl.add(() => {
            [this._animationBelow, this._animationAbove].forEach((item: PIXI.spine.Spine) => {
                item.visible = true;
                item.updateTransform();
                item.state.clearTracks();
                item.state.setEmptyAnimation(0, 0);
            });

            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.FS_INTRO
            });
        }, 0);
        tl.add([
            WalkOfShameHelper.createTimelineForAnimation(this._animationBelow, 0, "beneathIn", false),
            WalkOfShameHelper.createTimelineForAnimation(this._animationAbove, 0, "aboveIn", false)
        ], 0);
        tl.add(() => {
            this._continueButton.visible = !isUpgrade;
            this._continueButton.enable(!isUpgrade);

            this._animationBelow.state.clearTracks();
            this._animationBelow.autoUpdate = true;
            this._animationBelow.state.setEmptyAnimation(0, 0);
            this._animationBelow.state.setAnimation(0, "beneathLoop", true);
            this._animationAbove.state.clearTracks();
            this._animationAbove.autoUpdate = true;
            this._animationAbove.state.setEmptyAnimation(0, 0);
            this._animationAbove.state.setAnimation(0, "aboveLoop", true);
        });

        if (isUpgrade) {
            tl.add([
                this.close(),
                () => {
                    WalkOfShameSound.soundPlayer.playTrack({
                        name: WalkOfShameSound.FS_END
                    });
                }
            ], "+=3").add(() => {
                if (this._continueCallback) {
                    this._continueCallback();
                }
            });
        }
    }

    protected close(): TimelineLite {
        // not calling super method in this case.

        const tl: TimelineLite = new TimelineLite,
            itemsArr: PIXI.DisplayObject[] = [this._bg, this._title, this._fsLeftCount, this._continueButton];
        tl.to(itemsArr, {
            duration: 0.6,
            alpha: 0
        }, 0);

        tl.add(() => {
            this._continueButton.enable(false);
            WalkOfShame.blackOverlay.hideOverlay(1);

            this._animationBelow.state.clearTracks();
            this._animationBelow.state.setEmptyAnimation(0, 0);
            this._animationBelow.state.setAnimation(0, "beneathOut", false);
            this._animationAbove.state.clearTracks();
            this._animationAbove.state.setEmptyAnimation(0, 0);
            this._animationAbove.state.setAnimation(0, "aboveOut", false);

            const nextMode: string = WalkOfShame.model.data.nextMode;
            WalkOfShame.multiplier.updateMultiplierText(WalkOfShame.model.parsedGameData ? WalkOfShame.model.parsedGameData.currentMultiplier : WalkOfShame.model.parsedInitData.currentMultiplier, false);
            WalkOfShame.multiplier.toggleMultiplier(true);

            WalkOfShame.updateMode(nextMode, false);
        }, 0);

        tl.add(() => {
            this.visible = false;

            itemsArr.forEach((item: PIXI.DisplayObject) => {
                item.visible = false;
                item.alpha = 1;
            });

            [this._animationBelow, this._animationAbove].forEach((item: PIXI.spine.Spine) => {
                item.visible = false;
                item.state.clearTracks();
            });
        });

        return tl;
    }
}